import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getCarousel = createAsyncThunk(
  'carousel/getCarousel',
  async () => {
    const carousel = await instanceAPI.get('/get-carousel')
      .then((resp) => resp.data.carousel);
    return carousel;
  },
);

const carouselSlice = createSlice({
  name: 'carousel',
  initialState: {
    carousel: [],
    status: null,
  },
  extraReducers: {
    [getCarousel.pending]: (state) => {
      state.status = 'loading';
    },
    [getCarousel.fulfilled]: (state, action) => {
      state.status = 'success';
      state.carousel = action.payload;
    },
    [getCarousel.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default carouselSlice.reducer;
